<template>
  <component :is="tag" :class="classes" v-bind="$attrs" @click="click">
    <!-- @slot Button text-->
    <m4-icon :icon="leftIcon" v-if="leftIcon"></m4-icon>
    <m4-icon v-if="basicIcon" :icon="basicIcon" class="btn__icon btn__icon--left"></m4-icon>
    <slot></slot>
  </component>
</template>

<script>
import callExternalFunction from "../../../utils/callExternalFunction";

export default {
  name: "M4Button",
  mixins: [callExternalFunction],
  props: {
    variant: {
      type: String
    },
    size: {
      type: String
    },
    leftIcon: {
      type: String
    },
    basicIcon: {
      type: String
    },
    icon: {
      type: Boolean
    },
    fullWidth: {
      type: Boolean
    },
    tag: {
      type: String,
      default: "button"
    },
    circle: {
      type: Boolean
    },
    noGutters: {
      type: Boolean
    }
  },
  emits: ["click"],
  computed: {
    classes() {
      let classes = ["btn"];
      if (this.variant && this.variant.indexOf("connect-app") > -1) {
        classes.push("btn--connect-app");
      }
      if (this.variant) {
        classes.push("btn--" + this.variant);
      }
      if (this.size) {
        classes.push("btn--" + this.size);
      }
      if (this.fullWidth) {
        classes.push("btn--full-width");
      } else if (this.circle) {
        classes.push("btn--circle");
      }
      if (this.leftIcon) {
        classes.push("btn--left-icon");
      }
      if (this.noGutters) {
        classes.push("btn--no-gutters");
      }
      return classes;
    }
  },
  methods: {
    click(e) {
      this.$emit("click", e);
      this.callExtFunc("click", e);
    }
  }
};
</script>
